import React from 'react';
import PropTypes from 'prop-types';
import {get as _get} from 'lodash';
import {withRouter} from 'react-router';

import {CircularProgress, Backdrop} from '@ui';

import {convertToInt} from '@utils/helpers';
import useQueryCustom from '@utils/hooks/useQueryCustom';
import {GetEventRedirectByEventContent} from "@graphql/event/query";
import {EventRedirect} from './EventRedirect';

export function EventRedirectByEventContent({
    history,
    match,
}) {
    const {
        data: {
            eventRedirectByEventContent
        } = {},
        error,
        loading: isDataLoading = true,
    } = useQueryCustom({
        query: GetEventRedirectByEventContent,
        options: {
            variables: {
                id: convertToInt(match.params.id),
            },
        },
    });

    return (isDataLoading && !error)
        ? (
            <Backdrop open inverted>
                <CircularProgress />
            </Backdrop>
        )
        : (
            <EventRedirect
                errorMessage='content'
                eventContentId={_get(eventRedirectByEventContent, 'event_content_id', null)}
                eventId={_get(eventRedirectByEventContent, 'event_id', null)}
                history={history}
            />
        );
}

EventRedirectByEventContent.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }),
};

export default withRouter(EventRedirectByEventContent);
